"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRM_ACTIVITY_MAX_PAGE_SIZE = exports.CRM_ACTIVITY_PAGE_SIZE = exports.CRM_ACTIVITY_LIST_CALLABLE = void 0;
/**
 * Contract for the `listCrmActivityEvents` callable. CRM activity events are
 * readable only through the callable — `firestore.rules` keeps the collection
 * admin-only — so this is the single shape every client sees.
 */
exports.CRM_ACTIVITY_LIST_CALLABLE = 'listCrmActivityEvents';
exports.CRM_ACTIVITY_PAGE_SIZE = 20;
exports.CRM_ACTIVITY_MAX_PAGE_SIZE = 50;
